const VIDEOS = [
  {
    id: "_m0u7s9PhOo",
    title: "B&P's Full Property Transformation",
    tag: "Before & After",
  },
  {
    id: "3eVFVqkf6E4",
    title: "Forestry Mulching in Action",
    tag: "Mulcher",
  },
  {
    id: "-mBrWutvCEI",
    title: "Gravel Driveway Improvement",
    tag: "Driveways",
  },
];

export const Videos = () => {
  return (
    <section id="videos" className="bg-[#0B131F] py-24" data-testid="videos-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#F5A623]">
            In the Field
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-3 uppercase">
            Watch Us Work
          </h2>
          <p className="mt-4 text-base text-slate-300 leading-relaxed">
            Real machines, real properties, real results — straight from our job sites around
            Almaguin and Muskoka.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VIDEOS.map((video) => (
            <figure key={video.id} data-testid="video-card" className="group">
              <div className="relative aspect-video overflow-hidden rounded-2xl border border-[#1E324A] group-hover:border-[#F5A623]/50 transition-colors duration-300">
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${video.id}?rel=0`}
                  title={video.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full"
                />
              </div>
              <figcaption className="mt-4">
                <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#F5A623]">
                  {video.tag}
                </span>
                <p className="font-display font-bold text-white text-base mt-1">{video.title}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
